<div class="headermaster">

  <div class="row">
    <div class="col-md-4 pl-0">
      <!-- <a class="navbar-brand" href="#">
        <img src="assets/images/logo.png" height="70" />
      </a> -->
      <nav class="navbar navbar-expand-sm top-banner">
        <!-- Brand/logo -->
        <img src="../../assets/images/logo.png" width="80" />
        <!-- Links -->
        <ul class="navbar-nav ml-2">
          <li class="nav-item">
            <div class="contentheader">สถาบันคุ้มครองเงินฝาก (สคฝ.)</div>
            <div class="contentheader2">Deposit Protection Agency(DPA)</div>
          </li>
        </ul>
      </nav>
    </div>
    <div class="col-md-8 pl-0 pr-0">
      <div class="w-100 h-50 text-right">
        <label class="text-white m-2">
          <span class="fa fa-lg fa-user-circle text-white"></span>
          {{dpa_name}}
        </label>

        <button type="button" class="btn btn-outline-light m-2" (click)="changePassword()">
          เปลี่ยนรหัสผ่าน
          <span class="fa fa-key"></span>
        </button>
        <button type="button" class="btn btn-outline-danger m-2" (click)="logout()">
          ออกจากระบบ
          <span class="fa fa-door-open"></span>
        </button>
      </div>
      <div class="w-100 h-50" style="border-top-left-radius: 10px; background-color: #0F50AC;">
        <div class="pt-3 h-100">
          <div class="marquee" *ngIf="role.dpa_tab_news">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="wrappermaster">

  <div class="container-fluid p-0">
    <div class="row justify-content-center menu-tab">
      <div class="col-11">
        <ul class="nav nav-tabs nav-justified d-flex" id="myTab" role="tablist">

          <li class="nav-item flex-even" *ngIf="role.dpa_tab_poolcase">
            <div class="row h-100 menu-container">
              <div class="bd-menu-left col-2"></div>
              <div class="col-8 p-0">
                <a class="nav-link user-menu" id="pool" data-toggle="tab" href="" role="tab"
                  aria-selected="false">
                  <img src="../../assets/images/poolCase.png" class="tab-icon">
                  <span class="badge badge-pill badge-danger"></span>
                  <br>
                  Pool Case
                </a>
              </div>
              <div class="bd-menu-right col-2"></div>
            </div>
          </li>

          <li class="nav-item flex-even" *ngIf="role.dpa_tab_case">
            <div class="row h-100 menu-container">
              <div class="bd-menu-left col-2"></div>
              <div class="col-8 p-0">
                <a class="nav-link user-menu" id="case" data-toggle="tab" href="" role="tab" aria-selected="false">
                  <img src="../../assets/images/case.png" class="tab-icon">
                  <span class="badge badge-pill badge-danger"></span>
                  <br>
                  My Case
                </a>
              </div>
              <div class="bd-menu-right col-2"></div>
            </div>
          </li>

          <li class="nav-item flex-even" *ngIf="role.dpa_tab_allcase">
            <div class="row h-100 menu-container">
              <div class="bd-menu-left col-2"></div>
              <div class="col-8 p-0">
                <a class="nav-link user-menu" id="shared" data-toggle="tab" href="" role="tab"
                  aria-selected="false">
                  <img src="../../assets/images/sharedCase.png" class="tab-icon">
                  <span class="badge badge-pill badge-danger"></span>
                  <br>
                  All Case
                </a>
              </div>
              <div class="bd-menu-right col-2"></div>
            </div>
          </li>

          <li class="nav-item flex-even" *ngIf="role.dpa_tab_contact">
            <div class="row h-100 menu-container">
              <div class="bd-menu-left col-2"></div>
              <div class="col-8 p-0">
                <a class="nav-link user-menu" id="contact" data-toggle="tab" href="" role="tab" aria-selected="false">
                  <img src="../../assets/images/contact.png" class="tab-icon">
                  <span class="badge badge-pill badge-danger"></span>
                  <br>
                  Contact
                </a>
              </div>
              <div class="bd-menu-right col-2"></div>
            </div>
          </li>

          <li class="nav-item flex-even" *ngIf="role.dpa_tab_chatbot" style="padding-left: 1px;">
            <div class="row h-100 menu-container">
              <div class="bd-menu-left col-2"></div>
              <div class="col-8 p-0">
                <a class="nav-link user-menu" id="chatbot" data-toggle="tab" href="" role="tab" aria-selected="false">
                  <img src="../../assets/images/chatbot.png" class="tab-icon">
                  <span class="badge badge-pill badge-danger">{{totalChatbot}}</span>
                  <br>
                  Chat bot
                </a>
              </div>
              <div class="bd-menu-right col-2"></div>
            </div>
          </li>

          <li class="nav-item flex-even" *ngIf="role.dpa_tab_socialmonitoring">
            <div class="row h-100 menu-container">
              <div class="bd-menu-left col-2"></div>
              <div class="col-8 p-0">
                <a class="nav-link user-menu" id="socialMedia" data-toggle="tab" href="" role="tab" aria-selected="false">
                  <img src="../../assets/images/socialMonitor.png" class="tab-icon">
                  <span class="badge badge-pill badge-danger">{{totalSocial}}</span>
                  <br>
                  Social Media Monitoring
                </a>
              </div>
              <div class="bd-menu-right col-2"></div>
            </div>
          </li>

          <li class="nav-item flex-even" *ngIf="role.dpa_tab_km">
            <div class="row h-100 menu-container">
              <div class="bd-menu-left col-2"></div>
              <div class="col-8 p-0">
                <a class="nav-link user-menu" id="knowledge" data-toggle="tab" href="" role="tab" aria-selected="false">
                  <img src="../../assets/images/knowledge.png" class="tab-icon">
                  <span class="badge badge-pill badge-danger"></span>
                  <br>
                  Knowledge Base
                </a>
              </div>
              <div class="bd-menu-right col-2"></div>
            </div>
          </li>

          <li class="nav-item flex-even" *ngIf="role.dpa_tab_report">
            <div class="row h-100 menu-container">
              <div class="bd-menu-left col-2"></div>
              <div class="col-8 p-0">
                <a class="nav-link user-menu" id="report" data-toggle="tab" href="" role="tab" aria-selected="false">
                  <img src="../../assets/images/report.png" class="tab-icon">
                  <span class="badge badge-pill badge-danger"></span>
                  <br>
                  Report
                </a>
              </div>
              <div class="bd-menu-right col-2"></div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>

  <!-- Control Sidebar -->
  <aside class="control-sidebar control-sidebar-dark">
    <!-- Control sidebar content goes here -->
  </aside>
  <!-- /.control-sidebar -->
</div>

<div class="barmaster" style="display: none;">
  <a class="nav-link navlink" data-widget="pushmenu" href="#" role="button" id='abar'><i
      class="fas fa-bars ibarmaster"></i></a>
</div>
<div class="manumaster" id="mumaster">
  <div id="divMenu" class="dmanu">
    <!-- <div class="groupmanu">
        <div class="headergroup">
          ข้อมูลหลัก
        </div>
        <div class="subgroup">
          ข้อมูลเลขที่ตำแหน่ง
        </div>
      </div> -->
  </div>
</div>
<div class="overmanu loadoverm" id="omanu">

</div>
<!-- ./wrapper -->
<!-- </div> -->



// WEBPACK FOOTER //
// ./src/app/mainmenu/mainmenu.component.html